// hooks/useCards.js - VERSIONE AXIOS
import { useState, useEffect } from 'react';
import axios from 'axios';

export const useCards = (theme = null) => {
    const [cards, setCards] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const source = axios.CancelToken.source();
        
        const fetchCards = async () => {
            try {
                setLoading(true);
                setError(null);
                
                let url = '/api/cards';
                if (theme) {
                    url = `/api/cards/theme/${theme}`;
                }

                console.log('🃏 Fetching cards from:', url);
                
                const response = await axios.get(url, {
                    cancelToken: source.token
                });
                
                console.log('✅ Cards response:', response.data.success ? `${response.data.data?.length || 0} cards` : 'Failed');
                
                if (response.data.success && Array.isArray(response.data.data)) {
                    setCards(response.data.data);
                } else {
                    setCards([]);
                    if (response.data.message) {
                        console.warn('⚠️ Unexpected response format:', response.data.message);
                    }
                }
                
            } catch (err) {
                if (!axios.isCancel(err)) {
                    console.error('❌ Error in useCards:', err.message);
                    setError(err.message);
                    setCards([]);
                }
            } finally {
                setLoading(false);
            }
        };
        
        fetchCards();
        
        return () => source.cancel('Component unmounted');
    }, [theme]);
    
    return { 
        cards, 
        loading, 
        error 
    };
};
